"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApplicationId = _interopRequireDefault(require("./ApplicationId"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RequestHeader model module.
 * @module model/RequestHeader
 * @version 1.0.44
 */
var RequestHeader = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RequestHeader</code>.
   * 
   * @alias module:model/RequestHeader
   */
  function RequestHeader() {
    _classCallCheck(this, RequestHeader);
    RequestHeader.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RequestHeader, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RequestHeader</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RequestHeader} obj Optional instance to populate.
     * @return {module:model/RequestHeader} The populated <code>RequestHeader</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RequestHeader();
        if (data.hasOwnProperty('applikationId')) {
          obj['applikationId'] = _ApplicationId.default.constructFromObject(data['applikationId']);
        }
        if (data.hasOwnProperty('bankId')) {
          obj['bankId'] = _ApiClient.default.convertToType(data['bankId'], 'String');
        }
        if (data.hasOwnProperty('timestamp')) {
          obj['timestamp'] = _ApiClient.default.convertToType(data['timestamp'], 'Date');
        }
        if (data.hasOwnProperty('sessionId')) {
          obj['sessionId'] = _ApiClient.default.convertToType(data['sessionId'], 'String');
        }
        if (data.hasOwnProperty('authToken')) {
          obj['authToken'] = _ApiClient.default.convertToType(data['authToken'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RequestHeader</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RequestHeader</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['bankId'] && !(typeof data['bankId'] === 'string' || data['bankId'] instanceof String)) {
        throw new Error("Expected the field `bankId` to be a primitive type in the JSON string but got " + data['bankId']);
      }
      // ensure the json data is a string
      if (data['sessionId'] && !(typeof data['sessionId'] === 'string' || data['sessionId'] instanceof String)) {
        throw new Error("Expected the field `sessionId` to be a primitive type in the JSON string but got " + data['sessionId']);
      }
      // ensure the json data is a string
      if (data['authToken'] && !(typeof data['authToken'] === 'string' || data['authToken'] instanceof String)) {
        throw new Error("Expected the field `authToken` to be a primitive type in the JSON string but got " + data['authToken']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {module:model/ApplicationId} applikationId
 */
RequestHeader.prototype['applikationId'] = undefined;

/**
 * Bankleitzahl des aktuellen Instituts
 * @member {String} bankId
 */
RequestHeader.prototype['bankId'] = undefined;

/**
 * UTC Zeit des Aufrufs
 * @member {Date} timestamp
 */
RequestHeader.prototype['timestamp'] = undefined;

/**
 * Session Id
 * @member {String} sessionId
 */
RequestHeader.prototype['sessionId'] = undefined;

/**
 * Authentizitäts Token
 * @member {String} authToken
 */
RequestHeader.prototype['authToken'] = undefined;
var _default = exports.default = RequestHeader;